<template>
  <div class="news-wrap container" v-if="list.length > 0">
    <div class="news_top">
      <titleConfig
        :title="langSet == 'cn' ? '新闻资讯' : 'News'"
        :type="1"
        :center="true"
      ></titleConfig>
    </div>
    <div class="news_list flex flex_wrap">
      <news
        class="news_item"
        :type="1"
        v-for="(item, index) in list"
        :key="index"
        :newsData="item"
      ></news>
    </div>
    <div
      class="news_more flex flex_content_center flex_items_center fb"
      @click="toMore"
    >
      {{ langSet == "cn" ? "查看更多" : "Learn More"
      }}<img :src="require('../../../assets/imgs/more.png')" alt="" />
    </div>
  </div>
</template>
<script>
import titleConfig from "@/components/title.vue";
import news from "@/components/news.vue";
import { articleList } from "@/api/api";
export default {
  components: {
    titleConfig,
    news,
  },
  data() {
    return {
      langSet: "",
      list: [],
    };
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.6 获取新闻资讯 dxm
    this.getList();
  },
  methods: {
    async getList() {
      let data = {
        page_no: 1,
        page_size: 4,
        lang: this.langSet,
      };
      const res = await articleList(data);
      this.list = res.data.lists;
    },
    toMore() {
      this.$router.push({
        path: "/news",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-wrap {
  margin-top: 120px;
  .news_top {
    margin-bottom: 38px;
  }
  .news_item {
    width: calc((100% - 120px) / 4);
    margin-right: 40px;
    &:nth-child(4) {
      margin-right: 0;
    }
  }
  .news_more {
    width: 228px;
    height: 50px;
    background: #cf121b;
    border-radius: 40px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    margin: 30px auto 0;
    img {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-left: 9px;
      background: #fff;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .news-wrap {
    .news_item {
      width: calc((100% - 60px) / 4);
      margin-right: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .news-wrap {
    margin-top: 1.15rem;
    position: relative;
    padding-bottom: 1rem;
    .news_item {
      width: 100%;
      margin-right: 0;
      margin-bottom: 0.38rem;
    }
    .news_top {
      margin-bottom: 0.38rem;
      .news_more {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 3.04rem;
        height: 0.69rem;
        font-size: 0.27rem;
        transform: translateX(-50%);
      }
    }
  }
}
</style>